const buildField = (field) => {
    let fieldValue = field.field
    let className = ''
    let validation = ''
    let inputRequired = `data-required="${field.required}" ${field.required ? 'required' : ''}`

    if (field.field === "dob") {
        fieldValue = "dob_slashes_mmddyyyy"
        className = 'path-input-mask-dob'
        validation = `placeholder='MM/DD/YYYY' pattern="^([0]?[1-9]|[1][0-2])[./-]([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0-9]{4}|[0-9]{2})$"`
    }
    if (field.field === "phone") {
        validation = "placeholder='(999) 999-9999'"
        className = 'path-input-mask-phone'
    }

    if (field.field === "zip")
        className = 'path-input-mask-zip'

    if (!field.visible)
        return ""

    let required = field.required ? `<span class="tcpa-required">*</span>` : ""
    let clazzRequired = field.required ? `is-required` : ""

    if (field.editable)
        return `
        <div class="tcpa-detail tcpa-field-${field.field} ${clazzRequired}">
            <div class="tcpa-title">${field.label} ${required}</div>
            <div class="tcpa-value">
            ${field.field === "gender" || field.field === 'state' ?
                Select(field.field, fieldValue, inputRequired)[field.field]
                :
                `<input type="text" class="tcpa-input ${className}" value="{${fieldValue}}" name="${field.field}" ${inputRequired} ${validation}/>`
            }
            </div>
        </div>
        `

    return `
        <div class="tcpa-detail tcpa-field-${field.field}">
            <div class="tcpa-title">${field.label}</div>
            <div class="tcpa-value">{${fieldValue}}</div>
        </div>
    `
}

const renderTrustedForm = (trustedform_cfid) => {
    return `
    <script type="text/javascript">
        (function() {
            var field = 'xxTrustedFormCertUrl';
            var provideReferrer = false;
            var invertFieldSensitivity = false;
            var tf = document.createElement('script');
            tf.type = 'text/javascript'; tf.async = true;
            tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') +
            '://api.trustedform.com/trustedform.js?field=' + escape(field) + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s); }
        )();
    </script>
    <noscript>
        <img src="http://api.trustedform.com/ns.gif" />
    </noscript>select custom_fields from users where id = 814
    `
}

const renderLeadId = (leadid_cfid) => {
    return `
    <script id="LeadiDscript" type="text/javascript">
    // <!--
    (function() {
    var s = document.createElement('script');
    s.id = 'LeadiDscript_campaign';
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//create.lidstatic.com/campaign/{{@system_config.jornaya.leadid_key}}.js?snippet_version=2';
    var LeadiDscript = document.getElementById('LeadiDscript');
    LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
    })();
    // -->
    </script>
    <noscript><img src='//create.leadid.com/noscript.gif?lac=934e3705-ae01-d5f3-9e2b-b9a54e634c7a&lck={{@system_config.jornaya.leadid_key}}&snippet_version=2' /></noscript>
    `
}

const renderLeadIdHidden = () => {
    return `
        <input id="leadid_token" name="universal_leadid" type="hidden" value=""/>
    `
}


const render = ({ cfid, title, confirmText, privacyDisclaimer, fields, trustedform, trustedform_cfid, leadid, leadid_cfid }) => {
    const trustedFormStr = trustedform === true ? renderTrustedForm(trustedform_cfid) : ''
    const leadIdStr = leadid === true ? renderLeadId(leadid_cfid) : ''

    var fieldsStr = (fields || []).map((field) => buildField(field)).join("")

    return `
<div class="tcpa-confirmation" data-tcpa="confirmation">
    <form class="tcpa-confirmation-form" action="{nextURL}" method="post">
    <h2>${title}</h2>
    <div class="tcpa-details">
        ${fieldsStr}
    </div>
    <div class="tcpa-confirm spacing">
        <label>
        <input class="tcpa-input-confirm" type="checkbox" data-field="${cfid}" 
            data-trustedform="${trustedform_cfid || ''}" data-leadid="${leadid_cfid || ''}"
            name="tcpa-confirm" value="true">
            ${confirmText}
        </label>
        <div class="tcpa-disclaimer">${privacyDisclaimer}</div>
    </div>
    <div class="spacing">
        ${trustedFormStr}
        ${leadid === true ? renderLeadIdHidden() : ''}
    </div>
    <input type='button' value='Continue' class="button block green big spacing userenroll-next"/>
    </form>
    ${leadIdStr}
</div>
    `.trim()
};

function Select(field, fieldValue, inputRequired) {
    const wrapper = options => {
        return `<select id='${field}' class="tcpa-input" name="${field}" value="{${fieldValue}}" ${inputRequired}>
            ${options}
        </select>
        <script>
            document.getElementById('${field}').value = '{${fieldValue}}'
        </script>`
    }

    const genderOptions = `
        <option value="" disabled>Select Gender</option>
        <option value="M">Male</option>
        <option value="F">Female</option>
    `
    const stateOptions = `
        <option value="" disabled>Select state</option>
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District Of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
        <option value="IA">Iowa</option>
        <option value="KS">Kansas</option>
        <option value="KY">Kentucky</option>
        <option value="LA">Louisiana</option>
        <option value="ME">Maine</option>
        <option value="MD">Maryland</option>
        <option value="MA">Massachusetts</option>
        <option value="MI">Michigan</option>
        <option value="MN">Minnesota</option>
        <option value="MS">Mississippi</option>
        <option value="MO">Missouri</option>
        <option value="MT">Montana</option>
        <option value="NE">Nebraska</option>
        <option value="NV">Nevada</option>
        <option value="NH">New Hampshire</option>
        <option value="NJ">New Jersey</option>
        <option value="NM">New Mexico</option>
        <option value="NY">New York</option>
        <option value="NC">North Carolina</option>
        <option value="ND">North Dakota</option>
        <option value="OH">Ohio</option>
        <option value="OK">Oklahoma</option>
        <option value="OR">Oregon</option>
        <option value="PA">Pennsylvania</option>
        <option value="RI">Rhode Island</option>
        <option value="SC">South Carolina</option>
        <option value="SD">South Dakota</option>
        <option value="TN">Tennessee</option>
        <option value="TX">Texas</option>
        <option value="UT">Utah</option>
        <option value="VT">Vermont</option>
        <option value="VA">Virginia</option>
        <option value="WA">Washington</option>
        <option value="WV">West Virginia</option>
        <option value="WI">Wisconsin</option>
        <option value="WY">Wyoming</option>
    `

    return {
        get gender() {
            return wrapper(genderOptions)
        },
        get state() {
            return wrapper(stateOptions)
        }
    }
}

export default render;